import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useComplexState } from 'hook/helper.hook';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import { MARKETPLACE_PRE_APPROVED_BANNER } from 'types/morph.pagePosition.constants';

export const useMarketplacePreApprovedBanner = (
  props,
  showPreApprovedBanner,
) => {
  const { eventHandler, onApprovalOddsChange, setCategory, config } = props;
  const onLinkClick = () => {
    eventHandler(CLICK, {
      'Click Type': 'See your offers',
      'Module Name': MARKETPLACE_PRE_APPROVED_BANNER,
      Vertical: CREDIT_CARD_VERTICAL,
    });
    setCategory('More Cards');
    onApprovalOddsChange(config?.marketplace?.cc?.preApprovedBannerFilterList);
  };
  return {
    onLinkClick,
    showBanner: showPreApprovedBanner,
  };
};
